/* Cache the searchable properties.
 * This avoid to loop between properties to search, translate and latinize with every keypress.
 * TODO: It would be interesting add fuzzy search as an option
 */

export function getSearchableStringfiedOptions(
  options: any[],
  propertiesToSearch: any[]
) {
  const searchableOptions = [...options];

  for (const option of searchableOptions) {
    let formatedOption = "";
    for (const property of propertiesToSearch) {
      if (property.latinize) {
        const latinizedProperty = latinize(option[property.text]);
        formatedOption = latinizedProperty
          ? formatedOption + "^" + latinizedProperty
          : formatedOption;
      } else {
        const optionStringedProperty = option[property?.text?.toString()];
        formatedOption = !!optionStringedProperty
          ? formatedOption + "^" + optionStringedProperty
          : formatedOption;
      }

      option._searchableText = formatedOption;
    }
  }
  return searchableOptions;
}

/* Latinize, trim and lowercase string to compare values */
export function latinize(value) {
  if (value && value?.length) {
    let formattedvalue = value?.trim().toLowerCase();

    formattedvalue = formattedvalue.replace(new RegExp(/[àáâãäå]/g), "a");
    formattedvalue = formattedvalue.replace(new RegExp(/[èéêë]/g), "e");
    formattedvalue = formattedvalue.replace(new RegExp(/[ìíîï]/g), "i");
    formattedvalue = formattedvalue.replace(new RegExp(/ñ/g), "ny");
    formattedvalue = formattedvalue.replace(new RegExp(/[òóôõö]/g), "o");
    formattedvalue = formattedvalue.replace(new RegExp(/[ùúûü]/g), "u");
    formattedvalue = formattedvalue.replace(new RegExp(/[ýÿ]/g), "y");

    return formattedvalue;
  }
}

/**
 * Returns an string trimed with an centered ellipsis according to qtty of characters to show
 */

export const centerEllipsisTrim = (
  text?: string,
  maxLength?: number,
  elipsis?: string
) => {
  if (!text) return text;
  if (!maxLength || maxLength < 1) return text;
  if (text.length <= maxLength) return text;
  if (maxLength == 1)
    return text.substring(0, 1) + elipsis ? elipsis : "........";

  var midpoint = Math.ceil(text.length / 2);
  var toremove = text.length - maxLength;
  var lstrip = Math.ceil(toremove / 2);
  var rstrip = toremove - lstrip;
  return (
    text.substring(0, midpoint - lstrip) +
    "........" +
    text.substring(midpoint + rstrip)
  );
};
